import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import AppMixin from './mixin'
// import client from 'webpack-theme-color-replacer/client'
// import getElementUISeries from 'webpack-theme-color-replacer/forElementUI/getElementUISeries'
// import themeConfig from './theme'
import Contextmenu from "vue-contextmenujs"
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './style/element.scss'
import '@zkwq/business/dist/index.min.css'
// import BaseUI from '@zkwq/business'

Vue.config.productionTip = false
// Vue.use(BaseUI);
Vue.use(ElementUI);
Vue.mixin(AppMixin);
Vue.use(Contextmenu);
Vue.prototype.$echarts = echarts;


// client.changer.changeColor({
//     newColors: themeConfig.getThemeColors('#5A84BD', getElementUISeries, client.varyColor, [])
// }, Promise).then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app")
// })



